import React, { useEffect, useState } from "react";
import { Calendar, Views, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Dialog, DialogContent } from "@material-ui/core";
import { SocialLinks, ClickToPhone } from "./SalientComponents.js";
import Agenda from "./CustomAgenda.js";


const localizer = momentLocalizer(moment);

const NotificationsPage = props => {
  const [events, setEvents] = useState([]);
  const[contacts,setContact] = useState([]);
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [eventPairs, setEventPairs] = useState([]);
  useEffect(() => {
    const fetchEvents = async wordpressId => {
      await fetch("/wp-json/prism/v1/calendar-events/" + wordpressId,{headers:{'X-WP-Nonce':props.nonce}})
        .then(response => response.json())
        .then(result => {setEvents(e => [...e, ...result]);
                        setContact(e => [...e, ...result])});
    };
    const fetchFollowups = async wordpressId => {
      await fetch("/wp-json/prism/v1/calendar-followups/" + wordpressId,{headers:{'X-WP-Nonce':props.nonce}})
        .then(response => response.json())
        .then(result => {setEvents(e => [...e, ...result]);
          setContact(e => [...e, ...result])});
    };
    if(props.wordpressId != null && props.nonce != null) {
      fetchEvents(props.wordpressId);
      fetchFollowups(props.wordpressId);
    }
  }, [props.wordpressId,props.nonce]);

  const EventInfo = () => {
    const field =
      preview != null && preview.event != null ? "event" : "followup";
    return preview != null ? (
      <Dialog
        open={open}
        onClose={() => {
          setPreview(null);
          setOpen(false);
        }}
        maxWidth="sm"
        fullWidth={true}
      >
        <DialogContent>
          <div style={{ display: "flex", width: "100%" }}>
            <div style={{ flex: 1 }}>
              {/* <i
                style={{
                  fontSize: "70px",
                  lineHeight: "70px",
                  height: "70px",
                  width: "70px",
                  color: "#a3a3a3"
                }}
                className="fa fa-user-circle hover-off"
              /> */}

               {/*=========== PS: SB 12/28/2020 Display Contact Image from Database if not null =======================*/}
               {(preview.contact != null && preview.contact.name !=  null && preview.contact.id != null) ? (
                <span>
               {preview.contact.pictureRef ==null|| preview.contact.pictureRef ==""?(
                  <i
                    style={{
                      fontSize: "70px",
                      lineHeight: "70px",
                      height: "70px",
                      width: "70px",
                      color: "#a3a3a3"
                    }}
                    className={"fa fa-user-circle hover-off"}
                  />
                   ):
                  (
                    <img
                      src={preview.contact.pictureRef}
                      style={{
                        fontSize: "70px",
                        lineHeight: "70px",
                        height: "70px",
                        width: "70px",
                        borderRadius: 50,
                      }}
                      className={ "fa fa-user-circle hover-off"}
                    />
                  )
                    }
                    </span>
               ):
               null }
                {/* =========================================================================== */}
                
            </div>          
            <div style={{ flex: 2 }}>
            {(preview.contact != null && preview.contact.name !=  null && preview.contact.id != null) ? (
              <a
                href={
                  "/prism/contact-detail/" +
                  preview.contact.name.replace(/\s/g, "") +
                  "/" +
                  preview.contact.id +
                  "?contactId=" +
                  preview.contact.id
                }
              >
                <strong>
                  {preview.contact.firstName} {preview.contact.lastName}
                </strong>
              </a>
              ) : null }
              <br />
              {preview.contact != null && preview.contact.emailOne != null &&
              preview.contact.emailOne !== "" ? (
                <a
                  href={"mailto:" + preview.contact.emailOne}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="icon-tiny fa fa-envelope-o extra-color-3" />
                </a>
              ) : null}
              {preview.contact != null && preview.contact.phoneOne != null ? (
                <ClickToPhone phone={preview.contact.phoneOne}/>
              ) : null}
              {preview.contact != null ? (
              <SocialLinks contact={preview.contact} />
              ) : null}
            </div>
            <div style={{ flex: 2 }}>
              {preview[field].type != null ? (
                <div>
                  <strong style={{ fontSize: "small", color: "#a3a3a3" }}>
                    {preview[field].type}
                  </strong>
                </div>
              ) : null}
              <div>
                <strong>{preview[field].title}</strong>
              </div>
              {preview[field].desc != null ? (
                <div>{preview[field].desc}</div>
              ) : null}
              {preview[field].date}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    ) : null;
  };

  return (
    <div>
       { <Calendar
        selectable
        localizer={localizer}
        views={{
          month: true,
          agenda:Agenda,
        }}
       // views={[Views.AGENDA,Views.MONTH]}
        events={events.map(m =>
          m["event"] != null ? m["event"] : m["followup"]
        )}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
        onSelectSlot={false}
        drilldownView="agenda"
        onSelectEvent={event => {
          const e = events.find(e => {
            const v = e["event"] != null ? e["event"] : e["followup"];
            return (
              parseInt(v.id, 10) === parseInt(event.id, 10) &&
              v.date === event.date
            );
          });
          console.log(e);
          setPreview(e);
          setOpen(true);
         
        }}
        defaultView={[Views.AGENDA]
        }
      />  
       }

      <EventInfo />
    </div>
  );
};

export default NotificationsPage;
